module.exports = __webpack_public_path__ + "fonts/roboto-v20-latin-700italic.da0e717.woff2";